import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { TrailerRentalSummary as i } from "../trailer-rental-summary/trailer-rental-summary.js";
import a from "./booking-completed.module.less.js";
import { useTranslation as c } from "react-i18next";
const h = ({
  bookingId: _,
  customerEmail: l,
  trailer: T,
  station: m,
  fromSlot: N,
  toSlot: d,
  bookingConfirmationAdditionalText: E
}) => {
  const { t: s } = c();
  return /* @__PURE__ */ r("div", { className: [a.wrapper, "max-width padded-sides centered"].join(" "), children: [
    /* @__PURE__ */ r("div", { className: "body-l", children: [
      /* @__PURE__ */ e("h1", { className: "h2", children: s("TRAILER_RENTAL_BOOKING_COMPLETED_HEADING") }),
      /* @__PURE__ */ r("p", { children: [
        s("TRAILER_RENTAL_BOOKING_COMPLETED_BOOKING_NUMBER_TEXT"),
        " ",
        /* @__PURE__ */ e("span", { className: a.emphasis, children: _ }),
        "."
      ] }),
      /* @__PURE__ */ r("p", { children: [
        s("TRAILER_RENTAL_BOOKING_COMPLETED_EMAIL_TEXT"),
        " ",
        /* @__PURE__ */ e("span", { className: a.emphasis, children: l }),
        "."
      ] }),
      /* @__PURE__ */ e("p", { children: s("TRAILER_RENTAL_BOOKING_COMPLETED_EXTRA_INFORMATION") }),
      E && E
    ] }),
    /* @__PURE__ */ e(i, { trailer: T, station: m, fromSlot: N, toSlot: d })
  ] });
};
export {
  h as BookingCompleted,
  h as default
};
